export const ROUTES = {
    general: {
        main: {
            name: "Main",
            route: "/",
        },
        login: {
            name: "Login",
            route: "/login",
        },
    },
    configuration: {
        projectSetup: {
            id: 10,
            name: "Project setup",
            route: "/configuration/project-setup",
        },
        tableSetup: {
            id: 20,
            name: "Table setup",
            route: "/configuration/table-setup",
            tabs: {
                tableSetup: {
                    id: 21,
                    name: "Overview",
                    route: "/configuration/table-setup?tab=table-setup",
                },
                translations: {
                    id: 22,
                    name: "Translations",
                    route: "/configuration/table-setup?tab=translations",
                },
                references: {
                    id: 23,
                    name: "References",
                    route: "/configuration/table-setup?tab=references",
                },
            }
        }
    },
    operation: {
        import: {
            id: 30,
            name: "Import",
            route: "/operation/import",
        },
        legacyMapping: {
            id: 40,
            name: "Legacy mapping",
            route: "/operation/legacy-mapping",
            tabs: {
                mapping: {
                    id: 41,
                    name: "Mapping",
                    route: "/operation/legacy-mapping?tab=mapping",
                },
                mappingTemplates: {
                    id: 42,
                    name: "Mapping templates",
                    route: "/operation/legacy-mapping?tab=mapping-templates",
                },
            }
        },
        migrationRules: {
            id: 50,
            name: "Migration rules",
            route: "/operation/migration-rules",
            tabs: {
                ruleOverview: {
                    id: 51,
                    name: "Rule Overview",
                    route: "/operation/migration-rules?tab=rule-overview",
                },
                ruleValues: {
                    id: 52,
                    name: "Rule Values",
                    route: "/operation/migration-rules?tab=rule-values",
                },
                ruleConditions: {
                    id: 53,
                    name: "Rule Conditions",
                    route: "/operation/migration-rules?tab=rule-conditions",
                },
                ruleResults: {
                    id: 54,
                    name: "Rule Results",
                    route: "/operation/migration-rules?tab=rule-results",
                },
            }
        },
        validationRules: {
            id: 60,
            name: "Validation rules",
            route: "/operation/validation-rules",
            tabs: {
                validationMapping: {
                    id: 61,
                    name: "Validation Mapping",
                    route: "/operation/validation-rules?tab=validation-mapping",
                },
                validationRules: {
                    id: 62,
                    name: "Validation Rules",
                    route: "/operation/validation-rules?tab=validation-rules",
                },
            }
        },
        enrichment: {
            id: 70,
            name: "Enrichment",
            route: "/operation/enrichment",
        },
        loadFileSetup: {
            id: 80,
            name: "Loadfile setup",
            route: "/operation/loadfile-setup",
        },
        clustering: {
            id: 90,
            name: "Clustering",
            route: "/operation/clustering"
        },
        publish: {
            id: 100,
            name: "Publish",
            route: "/operation/publish"
        }
    },
    batchProcessing: {
        processOverview: {
            id: 90,
            name: "Process overview",
            route: "/batch-processing/process-overview",
        },
        jobsOverview: {
            id: 100,
            name: "Jobs overview",
            route: "/batch-processing/jobs-overview",
        },
    },
    administration: {
        userManagement: {
            id: 110,
            name: "User management",
            route: "/administration/user-management",
        },
        groupManagement: {
            id: 120,
            name: "Group management",
            route: "/administration/group-management",
        },
        account: {
            id: 150,
            name: "My account",
            route: "/administration/my-account",
        },
        applicationSettings: {
            id: 160,
            name: 'Application Settings',
            route: '/administration/application-settings',
        },
    },
    report: {
        demo: {
            id: 200,
            name: "Demo",
            route: "/report/demo",
        },
        customQuery: {
            id: 210,
            name: "Custom Queries",
            route: "/report/custom-queries/:id",
        },
        unfinishedMappings: {
            id: 220,
            name: "Unfinished Mappings",
            route: "/report/unfinished-mappings",
        },
        manuals: {
            id: 230,
            name: 'Manuals',
            route: '/report/manuals',
        },
        releaseNotes: {
            id: 240,
            name: 'Release Notes',
            route: '/report/release-notes',
        },
        customQueries: {
            id: 250,
            name: 'Custom Queries',
            route: '/report/custom-queries',
        },
        analytics: {
            id: 170,
            name: 'Analytics',
            route: '/report/analytics'
        }
    },
    notifications: {
        id: 201,
        name: "Notifications",
        route: "/notifications",
    },

    excelAddin: {
        excelSettings: {
            id: 300,
            name: "Excel Settings",
            route: "/excel-addin/access-management",
            tabs: {
                userManagement: {
                    id: 301,
                    name: "User Management",
                    route: "/excel-addin/access-management?tab=user-management",
                },
                roleManagement: {
                    id: 302,
                    name: "Role Management",
                    route: "/excel-addin/access-management?tab=role-management",
                },
            }
        },
        viewManagement: {
            id: 310,
            name: "View Management",
            route: "/excel-addin/view-management",
        }
    }

}